import { Building2, Percent, FileCheck, Wallet } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";

const settingsMenuItems = [
  {
    key: "company-info",
    label: "Company Information",
    icon: <Building2 size={18} />,
    to: "company-info",
  },
  {
    key: "taxes",
    label: "Tax Rates",
    icon: <Percent size={18} />,
    to: "taxes",
  },
  {
    key: "terms",
    label: "Invoice Terms",
    icon: <FileCheck size={18} />,
    to: "terms",
  },
  {
    key: "payment-methods",
    label: "Payment Methods",
    icon: <Wallet size={18} />,
    to: "payment-methods",
  },
];

export default function BillingSettingsLayout() {
  return (
    <div className="w-full h-full flex flex-col gap-8">
      {/* Settings Horizontal Menu */}
      <div className="w-full p-2 bg-white rounded-2xl shadow-md">
        <nav className="flex space-x-2">
          {settingsMenuItems.map((item) => (
            <NavLink
              key={item.key}
              to={item.to}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-3 rounded-xl text-left transition-colors 
                ${
                  isActive
                    ? "bg-green-600 text-white"
                    : "text-gray-800 hover:bg-gray-100"
                }`
              }
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Settings Content */}
      <div className="flex-1 bg-white rounded-2xl shadow-md p-6">
        <Outlet />
      </div>
    </div>
  );
}
